import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

/**
 * Swiper Slider
 */
function swiperSlider(selector = '', config = {}) {
	if (!selector) return;

	// Add relevant modules, based on config
	const modules = [];

	if ('pagination' in config) modules.push(Pagination);
	if ('navigation' in config) modules.push(Navigation);
	if ('autoplay' in config) modules.push(Autoplay);
	if ('fadeEffect' in config && config.fadeEffect.crossFade === true)
		modules.push(EffectFade);

	if (modules.length > 0) config.modules = modules;

	// Start Slider!
	const swiper = new Swiper(selector, config);

	// Set Pause on hover if autoplay is active
	if ('autoplay' in config) {
		const swiperContainer = document.querySelector(selector);

		swiperContainer.addEventListener('mouseover', () => {
			swiper.autoplay.stop();
		});

		swiperContainer.addEventListener('mouseout', () => {
			swiper.autoplay.start();
		});
	}
}

export default swiperSlider;
